<template>
  <ElementsFormField :label="label" :id="id" :name="name" :error="error">
    <label class="input">
      <Icon v-if="icon" :name="icon" />
      <input
        v-bind="$attrs"
        :name="name"
        :id="id ?? name"
        :type="type"
        :value="modelValue"
        @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
      />
      <Icon v-if="type?.startsWith('date')" name="ri:calendar-2-line" :size="20" />
    </label>
  </ElementsFormField>
</template>

<script setup lang="ts">
  defineProps<{
    label?: string
    name?: string
    id?: string
    error?: string
    icon?: string
    type?: string
    modelValue?: any
  }>()

  defineEmits(["update:modelValue"])
</script>

<style lang="scss" scoped>
  .input {
    display: flex;
    align-items: center;
    min-height: var(--input-min-height);
    padding: var(--input-padding-y) var(--input-padding-x);
    gap: var(--input-gap);
    border: 1px solid var(--status-color, #e0e0e0);
    background: #ffffff;
    outline: none;
    transition: all 0.2s;
    cursor: text;
    color-scheme: light;

    :deep(svg) {
      font-size: 14px;
      pointer-events: none;
    }
    input {
      background: transparent;
      min-width: 0;
      width: 100%;
      height: 36px;
      flex: 1;
      border: 0;
      color: rgba(40, 40, 40, 1);
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.28px;
      outline: none !important;
      padding: 0;

      &:is([type="date"], [type="time"], [type="datetime-local"]) {
        appearance: none;
        margin-right: -30px;

        &::-webkit-calendar-picker-indicator,
        &::-webkit-inner-spin-button {
          color: transparent;
          opacity: 0;
          cursor: pointer;
          width: 36px;
          height: 36px;
        }
      }

      &::placeholder {
        color: rgba(40, 40, 40, 0.6);
      }
      &:disabled {
        pointer-events: none;
      }
    }

    &:has(:disabled) {
      cursor: not-allowed;
      opacity: 0.5;
    }
    &:focus-within {
      border-color: var(--status-color, #b3b3b3);
    }
  }
</style>
